import { Link } from "react-router-dom";
import { Linkedin, Mail, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-12">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-md bg-gradient-to-br from-blue-500 to-cyan-400 grid place-items-center font-display font-extrabold text-black text-sm">
              {SITE.initials}
            </div>
            <div>
              <div className="font-display font-bold text-white">{SITE.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                {SITE.domain}
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-slate-400 max-w-sm leading-relaxed">
            Senior corporate trainer & consultant — Microsoft, Cloud, Cybersecurity
            and AI Security. Trusted by Fortune 500 teams across 4 continents.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={SITE.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-white/30 text-slate-300 hover:text-white transition-colors"
              data-testid="footer-linkedin"
            >
              <Linkedin size={16} />
            </a>
            <a
              href={`mailto:${SITE.email}`}
              aria-label="Email"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-white/30 text-slate-300 hover:text-white transition-colors"
              data-testid="footer-email"
            >
              <Mail size={16} />
            </a>
            <a
              href={SITE.whatsappLink}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:border-white/30 text-slate-300 hover:text-white transition-colors"
              data-testid="footer-whatsapp"
            >
              <MessageCircle size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-4">Site</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><a href="#expertise" className="hover:text-white">Expertise</a></li>
            <li><a href="#services" className="hover:text-white">Services</a></li>
            <li><a href="#testimonials" className="hover:text-white">Voices</a></li>
            <li><a href="#blog" className="hover:text-white">Insights</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-4">Engage</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><a href="#contact" className="hover:text-white">Book a call</a></li>
            <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-4">Reach</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
            <li><a href={SITE.whatsappLink} className="hover:text-white">{SITE.whatsapp}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 px-6 md:px-10 py-6 max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Ajay Sahni. All rights reserved.</div>
        <div className="font-mono uppercase tracking-[0.22em]">{SITE.domain}</div>
      </div>
    </footer>
  );
}
